/* --------------------------------
[JSファイルの説明]
・gulpで scripts.json の libs の各ファイルを連結し、 /js/libs.js に書き出している
・gulpで scripts.json の scripts の各ファイルを連結＆圧縮し、 /js/scripts.js に書き出している
・HTMLでは上記の libs.js と scripts.js を読み込んでいる
・もしもgulpの環境が無くて更新が困難な場合は、書き出したJSは無視して scripts.json の各ファイルをHTMLで直接読み込んでも動作は可能
-------------------------------- */

// スクロールバーを除いたウィンドウ幅をCSSのカスタムプロパティに設定
const setVw = function() {
  const vw = document.documentElement.clientWidth;
  document.documentElement.style.setProperty('--vw', `${vw}px`);
}
window.addEventListener('DOMContentLoaded', setVw);
window.addEventListener('resize', setVw);

//aタグ スムーススクロール
$(function(){
  $('a[href^="#"]').click(function(){
    var speed = 500;
    var href= $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var position = target.offset().top;
    $("html, body").animate({scrollTop:position}, speed, "swing");
    return false;
  });
});

//スライダー
$(function(){
  $('.home-kv__slick').each(function(index, el) {
    const $slider = $(this);

    $slider.slick({
      autoplay: true,
      autoplaySpeed: 3000,
      fade: true,
      speed: 1000,
      pauseOnFocus: false,
      pauseOnHover: false,
      pauseOnDotsHover: false,
      arrows: false,
      dots: false
    });
  });
});

//フェード
$(function(){
  var fade = $('.u-fade, .js-fadeAni');

  fade.each(function(index, el) {
    var t = $(this);

    setTimeout(function(){
      $(window).on('resize scroll', function(event) {
        run();
      });

      run();
    }, 200);

    function run() {
      var winT = $(window).scrollTop();
      var winH = $(window).innerHeight();
      var winB = winT + winH;
      var tT = t.offset().top;
      var tH = t.innerHeight();
      var tB = tT + tH;

      var pointH = tT + 50;
      var pointSc = winB;
      var pointD = 200;

      var h = t.attr('data-fade-h');
      if(h) {
        pointH = tT + tH * h / 100;
      }

      var sc = t.attr('data-fade-sc');
      if(sc) {
        pointSc = winT + winH * sc / 100;
      }

      var d = t.attr('data-fade-delay');
      if(d) {
        pointD = d;
      }

      if(pointH < pointSc) {
        setTimeout(function(){
          t.addClass('is-fade');
          next();
        }, pointD);
      }
    }

    function next() {
      var nextStr = t.attr('data-fade-next-target');
      if(nextStr) {
        var nextArr = nextStr.split(' ');
        if(nextArr) {
          for (var i = 0; i < nextArr.length; i++) {
            var next = nextArr[i];
            var nextTar = $('[data-fade-next-id="' + next + '"]');
            if(nextTar[0]) {
              var nextDelay = t.attr('data-fade-next-delay');
              var delay = 200;
              if(nextDelay) {
                delay = parseInt(nextDelay);
              }

              var nextStep = t.attr('data-fade-next-step');
              var step = 200;
              if(nextDelay) {
                step = delay;
              }
              if(nextStep) {
                step = parseInt(nextStep);
              }

              nextTar.each(function(index, el) {
                var t2 = $(this);
                var step2 = step * index + delay;

                setTimeout(function(){
                  t2.addClass('is-fadeNext');
                  t2.attr('data-test', step2);
                }, step2);
              });
            }
          }
        }
      }
    }
  });
});

$(function () {
  var video_pc = document.getElementsByTagName('video')[0];
  var video_sp = document.getElementsByTagName('video')[1];

  video_pc.addEventListener('ended', function () {
    $('body').addClass('is-end');
    $('.js-moviePlayerAuto').remove();
  }, false);

  video_sp.addEventListener('ended', function () {
    $('body').addClass('is-end');
    $('.js-moviePlayerAuto').remove();
  }, false);

  //skip
  $('.ast2504-kv__skip a').on('click', function(e) {
    $(this).parent().addClass('is-on');
    $('body').addClass('is-end2');

    $('.js-moviePlayerAuto').remove();
  });

});


var youtubeTag = document.createElement('script');
youtubeTag.src = "https://www.youtube.com/iframe_api";
var youtubeFirstScriptTag = document.getElementsByTagName('script')[0];
youtubeFirstScriptTag.parentNode.insertBefore(youtubeTag, youtubeFirstScriptTag);
var youtubePlayers = [];

function onYouTubeIframeAPIReady() {
  // $('.js-moviePlayerAuto').each(function(index, el) {
  //   var t = $(this);
  //   t.attr('data-player-id', youtubePlayers.length);

  //   var id = t.attr('data-video-id');

  //   if (window.matchMedia("(max-width: 767px)").matches) {
  //     id = t.attr('data-video-id-sp');
  //   }

  //   var player = new YT.Player(t[0], {
  //     height: '360',
  //     width: '640',
  //     videoId: id,
  //     playerVars: {
  //     'modestbranding': 1,
  //     'autohide': 1,
  //     'controls': 0,
  //     'showinfo': 0,
  //     'rel': 0,
  //     'autoplay': 1,
  //     'playsinline': 1,
  //     'loop': 0,
  //     'playlist': id
  //     },
  //     events: {
  //       'onReady': onPlayerReady,
  //       'onStateChange': onPlayerStateChange
  //     }
  //   });
  //   youtubePlayers.push(player);

  //   function onPlayerStateChange(event) {
  //     var ytStatus = event.target.getPlayerState();

  //     // 再生終了したとき
  //     if (ytStatus == YT.PlayerState.ENDED) {
  //       // event.target.seekTo(0,true);//動画の初めにシーク
  //       // event.target.mute();
  //       // event.target.playVideo();
  //       $('body').addClass('is-end');

  //       setTimeout(function(){
  //         $('.js-moviePlayerAuto').remove();
  //         p.stopVideo();
  //       }, 0);
  //     }
  //   }

  //   //skip
  //   $('.ast2504-kv__skip a').on('click', function(e) {
  //     $(this).parent().addClass('is-on');
  //     $('body').addClass('is-end2');

  //     setTimeout(function(){
  //       $('.js-moviePlayerAuto').remove();
  //       p.stopVideo();
  //     }, 1000);
  //   });

  //   // 4. The API will call this function when the video player is ready.
  //   function onPlayerReady(event) {
  //     event.target.mute();
  //     event.target.playVideo();
  //   }

  //   function playVideo() {
  //     player.mute();
  //     player.playVideo();
  //   }

  //   function stopVideo() {
  //     player.stopVideo();
  //   }
  // });

  setTimeout(function(){
    $('.js-youtubePlayerModalFrame').each(function(index, el) {
      var t = $(this);
      t.attr('data-player-id', youtubePlayers.length);

      var player = new YT.Player(t[0], {
        height: '360',
        width: '640',
        videoId: t.attr('data-video-id'),
        playerVars: {
        'modestbranding': 1,
        'autohide': 1,
        'controls': 1,
        'showinfo': 0,
        'rel': 0,
        'autoplay': 0,
        'playsinline': 1
        },
        events: {
          'onReady': onPlayerReady,
          'onStateChange': onPlayerStateChange
        }
      });
      youtubePlayers.push(player);

      function onPlayerStateChange(event) {
        var ytStatus = event.target.getPlayerState();

        // 再生終了したとき
        if (ytStatus == YT.PlayerState.ENDED) {
          player.seekTo(0,true);//動画の初めにシーク
          player.stopVideo();

          $('[data-remodal-action="close"]').trigger('click');
        }
      }

      // 4. The API will call this function when the video player is ready.
      function onPlayerReady(event) {
        //event.target.mute();
        // event.target.playVideo();
      }

      function playVideo() {
        player.mute();
        player.playVideo();
      }

      function stopVideo() {
        player.stopVideo();
      }
    });

    $('.js-youtubePlayerModal').each(function(index, el) {
      var t = $(this);

      t.on('opening', function () {
      });

      t.on('opened', function () {
        var p = youtubePlayers[t.find('.js-youtubePlayerModalFrame').attr('data-player-id')];
        p.playVideo();
      });

      t.on('closing', function (e) {
        var p = youtubePlayers[t.find('.js-youtubePlayerModalFrame').attr('data-player-id')];
        p.stopVideo();
      });

      t.on('closed', function (e) {
        var p = youtubePlayers[t.find('.js-youtubePlayerModalFrame').attr('data-player-id')];
        p.stopVideo();
      });
    });
  }, 100);
}